<template>
    <PageFull header="Кошелек" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full px-3">                            
                <div v-if="wallet" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row" >
                    <div class="w-full flex flex-column" >
                        <div v-if="wallet" class="w-full flex flex-column gap-0">
                            <div v-if="wallet.id" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Wallet ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ wallet.id }}
                                    </span>
                                </span>...
                                <Button @click="copy(wallet.id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="wallet.user_id" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Wallet User ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ wallet.user_id }}
                                    </span>
                                </span>...
                                <Button @click="copy(wallet.user_id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                                <Button @click="goToUser(wallet.user_id)" icon="pi pi-external-link" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                            <div v-if="wallet.type" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Тип: 
                                </span>
                                <span class="flex flex-row gap-2 my-auto overflow-hidden">
                                    <Tag class="flex" :value="GetWalletNameByLabel(wallet.type)" :class="getClassByLabel(wallet.type)" />
                                    <Tag class="flex" :value="GetWalletNameByLabel(wallet.ext_type)" :class="getClassByLabel(wallet.ext_type)"/>
                                </span>
                                <Button @click="copy(wallet.ext_type)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Баланс: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formaAmount(wallet.balance, wallet.currency, 2) }} ({{ wallet.balance }} {{ wallet.currency }})
                                </span>
                                <Button @click="copy(wallet.balance)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="wallet.description" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Описание: 
                                </span>
                                <span class="flex my-auto overflow-hidden bg-yellow-100">
                                    {{ wallet.description }}
                                </span>
                                <Button @click="copy(wallet.description)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                            <div v-if="wallet.created_at" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Создан: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formatDate(wallet.created_at) }}
                                </span>
                                <Button @click="copy(wallet.created_at)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div v-if="wallet.updated_at" class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Обновлен: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ formatDate(wallet.updated_at) }}
                                </span>
                                <Button @click="copy(wallet.updated_at)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                        </div>

                        <AccountList v-if="wallet.accounts" :accounts="wallet.account_details" :total="totalRecords" :loading="loading"
                            @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams" />

                    </div>
                </div>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import PageFull from '@/components/sides/PageFull.vue'
import AccountList from '@/components/admin/account/list.vue'

export default {
    data() {
        return {
            // wallet_id: null,
            wallet: null,
            accounts: null,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalRecords: 0,
            loading: false,
        }
    },
    components: {
        PageFull,
        AccountList
    },
    methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goToUser(id){
            if(!id) return
            window.open(`/admin/user/${id}/`, '_blank')
        },
        formaAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadLazyData();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadLazyData()
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            const wallet = await this.connect.get_wallet_by_id(this.wallet_id).then(res => res)
            if (wallet.result && wallet.data) {
                // 
                this.wallet = wallet.data
                this.accounts = wallet.data.accounts
                this.totalRecords = wallet.data.accounts.length
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.wallet_id = route.params.id            
        }
    },
    async mounted() {
        this.loadLazyData();
    },
}
</script>